<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col>
          <el-button type="primary" @click="goAddpage" v-if="canLook == 1">添加活动</el-button>
        </el-col>
      </el-row>
      <div class="tip">提示：活动过期或者活动被关闭，该活动已分配的经销商将不再绑定该活动，修改活动生效后请重新分配给经销商</div>
      <el-table :data="catelist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="活动内容" prop="name" width="130px"></el-table-column>
        <el-table-column label="活动结束时间" prop="endTime" width="130px"></el-table-column>
        <el-table-column label="默认可享受次数" prop="userSharedCount" width="90px"></el-table-column>
        <el-table-column label="创建时间" prop="create_at" width="120px"> </el-table-column>

        <el-table-column label="是否可用" width="90px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="stateChanged(scope.row)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="editById(scope.row.id)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="querInfo.pagenum"
        :page-sizes="[3, 5, 10, 15]"
        :page-size="querInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canLook: 1,
      // 查询条件
      querInfo: {
        pagenum: 1,
        pagesize: 5
      },
      // 商品分类的数据列表，默认为空
      catelist: [],
      // 总数据条数
      total: 0,

      // 控制添加分类对话框的显示与隐藏
      addCateDialogVisible: false,
      // 添加分类的表单数据对象
      addCateForm: {
        attr_name: '',
        attr_num: '',
        attr_kucun: '',
        attr_weight: '',
        attr_price: '',
      },
      // 添加分类表单的验证规则对象
      addCateFormRules: {
        attr_name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
        , attr_num: [{ required: true, message: '请输入规格量，如12盒', trigger: 'blur' }]
        , attr_kucun: [{ required: true, message: '请输入该规格库存', trigger: 'blur' }]
        , attr_weight: [{ required: true, message: '请输入该规格重量', trigger: 'blur' }]
        , attr_price: [{ required: true, message: '请输入该规格价格', trigger: 'blur' }]
      },

    }
  },
  created () {
    this.getActivityList()
  },
  methods: {

    // 根据Id删除对应的用户信息
    async removeById (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除该活动, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/activity/delete', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除用户失败！')
      }
      this.$message.success('删除用户成功！')
      this.getActivityList()
    },

    // 监听 switch 开关状态的改变
    async stateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/activity/update', {
        status: userinfo.status,
        id: userinfo.id
      })
      if (res.code !== 200) {
        userinfo.status = !userinfo.status
        return this.$message.error('更新状态失败！')
      }
      this.$message.success('更新状态成功！')
    },

    // 获取活动列表数据
    async getActivityList () {
       if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      const { data: res } = await this.$http.get('admin/activity/getActivityList', {
        params: this.querInfo
      })

      if (res.code !== 200) {
        return this.$message.error('获取活动列表失败！')
      }

      console.log(res.result)
      // 把数据列表，赋值给 catelist
      this.catelist = res.result.list
      // 为总数据条数赋值
      this.total = res.result.count
     
    },
    // 监听 pagesize 改变
    handleSizeChange (newSize) {
      this.querInfo.pagesize = newSize
      this.getActivityList()
    },
    // 监听 pagenum 改变
    handleCurrentChange (newPage) {
      this.querInfo.pagenum = newPage
      this.getActivityList()
    },

    // 点击按钮，展示添加分类的对话框
    showAddCateDialog () {
      this.addCateDialogVisible = true
    },
    // 新建活动
    goAddpage () {
      this.$router.push('/goods/addActivity')
    },

    // 编辑活动
    editById (id) {
      this.$router.push({ path: '/goods/addActivity', query: { id: id } })
    },

    // 点击按钮，添加新的分类
    addCate () {
      this.$refs.addCateFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/good/addGoodAttr', this.addCateForm)

        if (res.code !== 200) {
          return this.$message.error('添加分类失败！')
        }
        this.$message.success('添加分类成功！')
        this.getCateList()
        this.addCateDialogVisible = false
      })
    },
    // 监听对话框的关闭事件，重置表单数据
    addCateDialogClosed () {
      this.$refs.addCateFormRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.treeTable {
  margin-top: 15px;
}

.tip{
  font-size:18px;
  color:#666666;
}

.el-cascader {
  width: 100%;
}
</style>
